import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { compose } from "redux"
import styled from "styled-components"

const Link = styled.a`
  color: ${prop => prop.theme.primaryColor} !important;
  &:hover {
    color: ${prop => prop.theme.primaryColorHover} !important;
  }
`

function Hyperlink({
  text, href, target, children, theme,
}) {
  return (
    <Link href={href} target={target} theme={theme}>
      {children || text}
    </Link>
  )
}

Hyperlink.propTypes = {
  text: PropTypes.string,
  href: PropTypes.string.isRequired,
  target: PropTypes.string,
  children: PropTypes.node,
  theme: PropTypes.shape({
    primaryColor: PropTypes.string.isRequired,
    primaryColorHover: PropTypes.string.isRequired,
    navBackgroundColor: PropTypes.string.isRequired,
  }).isRequired,
}

Hyperlink.defaultProps = {
  target: "_self",
  text: null,
  children: null,
}

function mapStateToProps(state) {
  return {
    theme: state.userDetail.theme,
  }
}

export default compose(connect(mapStateToProps))(Hyperlink)



// WEBPACK FOOTER //
// ./src/components/themed-html-components/Hyperlink.jsx